module.exports = "<p>\r\n  izvestaj-o-popunjenosti-reklamnih-blokova works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/izvestaji/izvestaj-o-popunjenosti-reklamnih-blokova/izvestaj-o-popunjenosti-reklamnih-blokova.component.html
// module id = ./src/app/pages/izvestaji/izvestaj-o-popunjenosti-reklamnih-blokova/izvestaj-o-popunjenosti-reklamnih-blokova.component.html
// module chunks = main